import React, { useState, useEffect } from 'react';
import AuthService from '../../services/api/auth';
import Stripe from '../../components/stripe';

const SepaScreen = ({ setStep, history }) => {
    const [pubKey, setPubKey] = useState('');

    useEffect(() => {
        setStep('PAYMENT');
        AuthService.getPubKey().then(pubKey => {
            setPubKey(pubKey);
        });
    }, [setStep]);

    return (
        <div className="container-fluid wrapper services">{pubKey && <Stripe pubKey={pubKey} history={history} />}</div>
    );
};

export default SepaScreen;
